import type { SVGProps } from "react";
const SvgArrowDown02Sharp1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 19V4M7 15l4.293 4.293c.333.333.5.5.707.5s.374-.167.707-.5L17 15"
    />
  </svg>
);
export default SvgArrowDown02Sharp1;
